// extracted by mini-css-extract-plugin
export var root = "Contact-module--root--mI96J";
export var section = "Contact-module--section--yNT2d";
export var contactForm = "Contact-module--contactForm---zN1V";
export var commentInput = "Contact-module--commentInput--GTE8U";
export var customButton = "Contact-module--customButton--Jmue2";
export var contactContainer = "Contact-module--contactContainer--3F-8u";